import React from 'react'
import { Button } from '@mui/material'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'

type ViewAllGeoLocationsButtonProps = {
  count: number
  onClick: () => void
}

const ViewAllGeoLocationsButton: React.FC<ViewAllGeoLocationsButtonProps> = ({ count, onClick }) => {
  const t = useAppTranslations()

  return (
    <Button onClick={onClick} variant="text" color="secondary" sx={{ flexShrink: 0, whiteSpace: 'nowrap', mb: '20px' }}>
      {t('adgroup.geoTargeting.viewAllLocations', { count })}
    </Button>
  )
}

export default ViewAllGeoLocationsButton
